import { z } from "zod";

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter valid email address"),
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

export const defaultValues: ForgotPasswordFormData = {
  email: "",
};

export const PAGE_CONFIG = {
  TITLE: "Forgot Password",
} as const;
